export { ComponentType };
/** 
 * Стили для компонента с типом.
 * 
 * Аналог выражения:
 * ```jsx
 * className={`my_component_${type} ${className}`}
 * ```
 * Но с проверками и сообщением об ошибке.
 * 
 * @summary Стили для компонента с типом.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class ComponentType {
  /**
   * @param {string} name - Название компонента.
   * @param {string} prefix - Префикс стилей для типов.
   * @param {Object} cls - Коллекция стилей.
   */
  constructor(name, prefix, cls) {
    this.name = name;
    this.prefix = prefix;
    this.cls = cls;
  }
  /**
   * @returns Полное className для компонента.
   * @param {string} [type=default] - Тип компонента.
   * @param {string} [className] - Дополнительные классы.
   * @example
   * import {ComponentType} from "../personal-studio-components/frame/index.js";
   * import * as cls from "./MyComponent.module.scss";
   * const cType = new ComponentType("MyComponent", "my_component_", cls);
   * function MyComponent({type = "default", className})
   * {
   *   const fullClassName = cType.getFullClassName(type, className);
   * }
   */
  getFullClassName(type = "default", className) {
    let fullClassName = this.cls[this.prefix + type];
    if (!fullClassName) {
      console.error(MSG.UNSUPPORTED_TYPE_OF, this.name, type);
      fullClassName = this.cls[this.prefix + "default"];
      if (!fullClassName) {
        console.error(MSG.UNSUPPORTED_TYPE_OF, this.name, "default");
        fullClassName = "";
      }
    }
    if (className) fullClassName += " " + className;
    return fullClassName;
  }
}
// Локализованные сообщения
const MSG = { UNSUPPORTED_TYPE_OF: "Неподдерживаемый тип %s: %s" };
